<template>
  <div class="page">
    <menu-item></menu-item>

    <div class="page-content">

      <!-- Video box -->
      <div class="vid-box bg-orange pure-g">
        <div class="vid-txt pure-u-1-1 pure-u-md-1-2">
          <h2 v-html="$lang.p_2_left_header"></h2>
          <h4 v-html="$lang.p_2_left_header_ingress"></h4>
          <p v-html="$lang.part_2_intro_text"></p>
        </div>

        <div class="vid-img pure-u-1-1 pure-u-md-1-2">
          <!--<div class="icon-wrapper" v-touch:tap="playVideo('275390409')">-->
          <div class="icon-wrapper" v-touch:tap="playVideo('improvements')">
            <div class="play-btn"></div>
            <div class="icon vid-bg"></div>
          </div>
        </div>
      </div>

      <!-- PART: Registerarbete -->
      <div class="p-section orange">
        <div class="p-box pure-g">
          <div class="box-left pure-u-1-1 pure-u-md-1-2">
            <h2 v-html="$lang.p_2_sec_4_header"></h2>
            <p v-html="$lang.p_2_sec_4_txt"></p>
          </div>
          <div class="pure-u-1-1 pure-u-md-1-2">
            <div class="icon-header right pure-g">
              <h3 class="pure-u-2-3" v-html="$lang.p_2_sec_4_document"></h3>
              <a :href="'./static/documents/01.pdf'" class="icon p-2-sheet-0 pure-u-1-3" download="studiematerial_01" v-touch:tap="downloadRegisterDocument"></a>
            </div>
          </div>
        </div>
      </div>

      <!-- PART: Informationsskyldighet -->
      <div class="p-section beige">
        <div class="education-box pure-g">
          <div class="e-box pure-u-1-1 pure-u-md-1-2">
            <div class="icon-header pure-g">
              <div class="icon p-2-sheet-1 pure-u-1-3"></div>
              <h3 class="pure-u-2-3" v-html="$lang.p_2_about_header_1"></h3>
            </div>
            <div v-html="$lang.p_2_about_para_1"></div>
          </div>
        </div>
      </div>
      <!-- PART: Arbetsgången -->
      <div class="p-section orange">
        <div class="p-box pure-g">
          <div class="box-left pure-u-1-1 pure-u-md-1-2">
            <h2 v-html="$lang.p_2_sec_6_header"></h2>
            <p v-html="$lang.p_2_sec_6_txt"></p>
          </div>
          <div class="pure-u-1-1 pure-u-md-1-2">
            <div class="icon-header right pure-g">
              <h3 class="pure-u-2-3" v-html="$lang.p_2_sec_4_document"></h3>
              <a :href="'./static/documents/02.pdf'" class="icon p-2-sheet-0 pure-u-1-3" download="studiematerial_02" v-touch:tap="downloadWorkDocument"></a>
            </div>

          </div>
        </div>
      </div>

      <!-- Small slider -->
      <sm-slider
        :slides="sliderThree"
      ></sm-slider>

      <!-- PART: Roller -->
      <div class="p-section orange">
        <div class="p-box pure-g">
          <div class="box-left pure-u-1-1 pure-u-md-1-2">
            <h2 v-html="$lang.p_2_sec_2_header"></h2>
            <p v-html="$lang.p_2_sec_2_txt"></p>
          </div>
          <div class="pure-u-1-1 pure-u-md-1-2">
            <div class="icon-header right pure-g">
              <h3 class="pure-u-2-3" v-html="$lang.p_2_sec_4_document"></h3>
              <a :href="'./static/documents/03.pdf'" class="icon p-2-sheet-0 pure-u-1-3" download="studiematerial_03" v-touch:tap="downloadRolesDocument"></a>
            </div>

          </div>
        </div>
      </div>

      <!-- Small slider -->
      <sm-slider
        :slides="sliderTwo"
        :specialClass="{absHClass: true}"
      ></sm-slider>

      <!-- PART: Utbildning -->
      <div class="p-section orange">
        <div class="p-box pure-g">
          <div class="box-left pure-u-1-1 pure-u-md-1-2">
            <h2 v-html="$lang.p_2_sec_3_header"></h2>
            <p v-html="$lang.p_2_sec_3_txt"></p>
          </div>
          <div class="pure-u-1-1 pure-u-md-1-2">
            <div class="icon-header right pure-g">
              <h3 class="pure-u-2-3" v-html="$lang.p_2_sec_4_document"></h3>
              <a :href="'./static/documents/04.pdf'" class="icon p-2-sheet-0 pure-u-1-3" download="studiematerial_04" v-touch:tap="downloadStudDocument"></a>
            </div>

          </div>
        </div>
      </div>

      <div class="p-section beige">
        <div class="education-box pure-g">
          <div class="e-box pure-u-1-1 pure-u-md-1-3">
            <div class="icon-header pure-g">
              <div class="icon p-2-sheet-1 pure-u-1-3"></div>
              <h3 class="pure-u-2-3" v-html="$lang.p_2_edu_header_1"></h3>
            </div>
            <div v-html="$lang.p_2_edu_para_1"></div>
          </div>
          <div class="e-box pure-u-1-1 pure-u-md-1-3">
            <div class="icon-header pure-g">
              <div class="icon p-2-sheet-2 pure-u-1-3"></div>
              <h3 class="pure-u-2-3" v-html="$lang.p_2_edu_header_2"></h3>
            </div>
            <div v-html="$lang.p_2_edu_para_2"></div>
          </div>
          <div class="e-box pure-u-1-1 pure-u-md-1-3">
            <div class="icon-header pure-g">
              <div class="icon p-2-sheet-3 pure-u-1-3"></div>
              <h3 class="pure-u-2-3" v-html="$lang.p_2_edu_header_3"></h3>
            </div>
            <div v-html="$lang.p_2_edu_para_3"></div>
          </div>
        </div>
      </div>

      <!-- PART: Implementering -->
      <div class="p-section orange">
        <div class="p-box pure-g">
          <div class="box-left pure-u-1-1 pure-u-md-1-2">
            <h2 v-html="$lang.p_2_sec_1_header"></h2>
            <p v-html="$lang.p_2_sec_1_txt"></p>
          </div>
          <div class="pure-u-1-1 pure-u-md-1-2">
            <div class="icon-header right pure-g">
              <h3 class="pure-u-2-3" v-html="$lang.p_2_sec_4_document"></h3>
              <a :href="'./static/documents/05.pdf'" class="icon p-2-sheet-0 pure-u-1-3" download="studiematerial_05" v-touch:tap="downloadImplementDocument"></a>
            </div>
          </div>
        </div>
      </div>

      <!-- Big slider -->
      <bg-slider
        :slides="sliderOne"
      ></bg-slider>

      <!-- Tips Box -->
      <div class="tips-box pure-g">
        <div class="tips-part left pure-u-1-1 pure-u-md-1-2">
          <div class="tips-header">
            <div class="icon missunderstanding"></div>
            <h3 v-html="$lang.tips_left_header"></h3>
          </div>
          <div class="tips-body" v-html="$lang.tips_left_txt"></div>
        </div>
        <div class="tips-part right pure-u-1-1 pure-u-md-1-2">
          <div class="tips-header">
            <div class="icon demands"></div>
            <h3 v-html="$lang.tips_right_header"></h3>
          </div>
          <p v-html="$lang.tips_right_hdr"></p>
          <div class="tips-body column-wrapper" v-html="$lang.tips_right_txt"></div>
        </div>
      </div>

      <!-- PART: Förbättringsarbete -->
      <div class="p-section orange">
        <div class="p-box pure-g">
          <div class="box-left pure-u-1-1 pure-u-md-1-2">
            <h2 v-html="$lang.p_2_sec_5_header"></h2>
            <!--<div v-html="$lang.p_2_sec_5_txt"></div>-->
          </div>
          <div class="pure-u-1-1 pure-u-md-1-2">
            <div class="icon-header right pure-g">
              <h3 class="pure-u-2-3" v-html="$lang.p_2_sec_4_document"></h3>
              <a :href="'./static/documents/06.pdf'" class="icon p-2-sheet-0 pure-u-1-3" download="studiematerial_06" v-touch:tap="downloadBetterDocument"></a>
            </div>

          </div>
        </div>
      </div>

      <div class="p-section beige">
        <div class="improve-box pure-g">
          <div class="l-box pure-u-1-1 pure-u-md-1-2">
            <div v-html="$lang.p_2_sec_5_txt_1"></div>
          </div>
          <div class="r-box pure-u-1-1 pure-u-md-1-2">
            <div v-html="$lang.p_2_sec_5_txt_2"></div>
            <p v-html="$lang.p_2_sec_5_txt_link"></p>
          </div>
              <!-- Video box -->
        <div class="vid-box vid-box-grid pure-g">
          <div class="pure-u-1-3">
            <div class="video-grid-header">
              <h3 v-html="$lang.video_grid_1_header"></h3>
            </div>
          <div class="vid-img vid-grid">
            <div class="icon-wrapper icon-grid" v-touch:tap="playVideo('individual1')">
              <div class="play-btn video-group"></div>
              <div class="icon vid-bg individual1"></div>
            </div>
            <div class="video-grid-breadcrum">
              <p v-html="$lang.video_grid_1_info"></p>
            </div>

          </div>
          <div class="vid-img vid-grid">
            <div class="icon-wrapper icon-grid" v-touch:tap="playVideo('individual2')">
              <div class="play-btn video-group"></div>
              <div class="icon vid-bg individual2"></div>
            </div>
            <div class="video-grid-breadcrum">
              <p v-html="$lang.video_grid_2_info"></p>
            </div>

          </div>

          </div>
          <div class="pure-u-1-3">
            <div class="video-grid-header">
              <h3 v-html="$lang.video_grid_2_header"></h3>
            </div>
          <div class="vid-img vid-grid">
            <div class="icon-wrapper icon-grid" v-touch:tap="playVideo('unit1')">
              <div class="play-btn video-group"></div>
              <div class="icon vid-bg unit1"></div>
            </div>
            <div class="video-grid-breadcrum">
              <p v-html="$lang.video_grid_3_info"></p>
            </div>

          </div>
          <div class="vid-img vid-grid">
            <div class="icon-wrapper icon-grid" v-touch:tap="playVideo('unit2')">
              <div class="play-btn video-group"></div>
              <div class="icon vid-bg unit2"></div>
            </div>
            <div class="video-grid-breadcrum">
              <p v-html="$lang.video_grid_4_info"></p>
            </div>

          </div>

          </div>
          <div class="pure-u-1-3">
            <div class="video-grid-header">
              <h3 v-html="$lang.video_grid_3_header"></h3>
            </div>
          <div class="vid-img vid-grid">
            <div class="icon-wrapper icon-grid" v-touch:tap="playVideo('kommun1')">
              <div class="play-btn video-group"></div>
              <div class="icon vid-bg kommun1"></div>
            </div>
            <div class="video-grid-breadcrum">
              <p v-html="$lang.video_grid_5_info"></p>
            </div>

          </div>
          <div class="vid-img vid-grid">
            <div class="icon-wrapper icon-grid" v-touch:tap="playVideo('kommun2')">
              <div class="play-btn video-group"></div>
              <div class="icon vid-bg kommun2"></div>
            </div>
            <div class="video-grid-breadcrum">
              <p v-html="$lang.video_grid_6_info"></p>
            </div>

          </div>

          </div>
        </div>
        </div>

      </div>

      <!-- To next part -->
      <div class="to-next-box p-2">
        <h4 v-html="$lang.done_part_one"></h4>
        <div class="btn-holder">
          <div class="btn white arrow" v-touch:tap="toPartTwo">
            <p>{{ $lang.to_part_small }} 2</p>
          </div>
          <div class="btn white arrow" v-touch:tap="toPartResource">
            <p>{{ $lang.to_part_recourse }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Menu from '../../../components/menu'
import BGSlider from '../../../components/big-slider'
import SMSlider from '../../../components/small-slider'
import PDFS from '../../../assets/data/recourse_pdf.json'

import DataSliderOne from '../../../assets/data/bg_sl_p2_1.json'
import DataSliderTwo from '../../../assets/data/sm_sl_p2_1.json'
import DataSliderThree from '../../../assets/data/sm_sl_p2_2.json'

export default {
  name: 'page-improv',
  data () {
    return {
      sliderOne: DataSliderOne.slides,
      sliderTwo: DataSliderTwo.slides,
      sliderThree: DataSliderThree.slides,
      pdfs: PDFS
    }
  },
  beforeMount () {
    this.$root.shared.currentPage = 'Improvement'
  },
  mounted () {
    // TODO: Just to force a update
    this.util.removeBodyClass('home-page')
    this.util.addBodyClass('improvement')
  },
  methods: {
    playVideo (id) {
      let self = this
      return () => {
        self.onPlayVideo(id)
      }
    },
    onPlayVideo (id) {
      this.$bus.$emit('VIDEO.PLAYVIDEO', {videoid: id})
    },
    toPartTwo () {
      let self = this
      return self.onToPartTwo()
    },
    onToPartTwo () {
      this.$router.push({name: 'Dementia'})
    },
    toPartResource () {
      let self = this
      return self.onToPartResource()
    },
    onToPartResource () {
      this.$router.push({name: 'Recourses'})
    },
    downloadRegisterDocument () {
      this.$ga.event('Downloads', 'click', 'Informationsskyldighet', 1)
    },
    downloadRolesDocument () {
      this.$ga.event('Downloads', 'click', 'Roller', 3)
    },
    downloadStudDocument () {
      this.$ga.event('Downloads', 'click', 'Utbildning', 2)
    },
    downloadWorkDocument () {
      this.$ga.event('Downloads', 'click', 'Arbetsgangen', 6)
    },
    downloadImplementDocument () {
      this.$ga.event('Downloads', 'click', 'Implementering', 7)
    },
    downloadBetterDocument () {
      this.$ga.event('Downloads', 'click', 'Forbattringsarbete', 8)
    }
  },
  beforeDestroy () {
    this.util.removeBodyClass('improvement')
  },
  components: {
    'menu-item': Menu,
    'sm-slider': SMSlider,
    'bg-slider': BGSlider
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/improvement/index.vue